import { removeStorage, setCookie } from '@lhb/cache';
import { dateFns, isObject } from '@lhb/func';
import { chooseTenant } from '@/common/api/tenant';
import { setValidTimeCookie } from '@/common/utils/ways';
import { mapFilter, mapTypeDimension } from '@/views/youth/pages/map/ts-config';

export async function switchTenant(tenantId: string | number) {
  const res: any = await chooseTenant({ tenantId });
  const { token, tenantId: nextTenantId, employeeId } = res || {};
  if (process.env.NODE_ENV !== 'development' && isObject(token)) {
    window.LHBbigdata.send({ event_id: 'console_pc_cookie_monitoring_token', msg: res });
  }
  nextTenantId && setCookie('tenantId', nextTenantId);
  employeeId && setCookie('employeeId', employeeId);
  token && setValidTimeCookie('flow_token', token);
  removeStorage(mapFilter);
  removeStorage(mapTypeDimension);
  removeStorage('reloadTimesTap');
  window.LHBbigdata.send({
    event_id: '67b7c29e-4d75-4b11-a417-3ea52a714c44',
    msg: { tenant_id: nextTenantId, user_id: employeeId, report_time: dateFns.currentTime('', false) },
  });
  return res;
}
